<template>
  <b-card no-body>
    <b-card-body v-if="canCreate">
      <div class="d-flex justify-content-end mb-1">
        <b-button
          variant="primary"
          :to="isGuidesTab ? '/app/guides/add' : '/app/tasks/add'"
        >
          <FeatherIcon icon="PlusIcon" /> {{ $t('common.create') }}
        </b-button>
      </div>
    </b-card-body>

    <b-tabs
      v-model="tabIndex"
      pills
      nav-class="mx-2"
      lazy
    >
      <!-- Aktif İş Akışları -->
      <b-tab :title="$t('tasks.tabs.active')">
        <template #title>
          <FeatherIcon icon="ActivityIcon" />
          {{ $t('tasks.tabs.active') }}
        </template>
        <tasks-table
          :fields="activeFields"
          :status-query="statusQueries.active"
        />
      </b-tab>

      <!-- Tamamlanan İş Akışları -->
      <b-tab :title="$t('tasks.tabs.completed')">
        <template #title>
          <FeatherIcon icon="CheckCircleIcon" />
          {{ $t('tasks.tabs.completed') }}
        </template>
        <tasks-table
          :fields="completedFields"
          :status-query="statusQueries.completed"
        />
      </b-tab>

      <!-- İptal Edilen İş Akışları -->
      <b-tab :title="$t('tasks.tabs.cancelled')">
        <template #title>
          <FeatherIcon icon="XCircleIcon" />
          {{ $t('tasks.tabs.cancelled') }}
        </template>
        <tasks-table
          :fields="cancelledFields"
          :status-query="statusQueries.cancelled"
        />
      </b-tab>

      <!-- Rehberler -->
      <b-tab
        v-if="showGuidesTab"
        :title="$t('tasks.tabs.guides')"
      >
        <template #title>
          <FeatherIcon icon="BookOpenIcon" />
          {{ $t('tasks.tabs.guides') }}
        </template>
        <guides-table />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BButton, BTabs, BTab,
} from 'bootstrap-vue'
import TasksTable from '@/views/Tasks/Components/TasksTable.vue'
import GuidesTable from '@/views/Guides/Components/GuidesTable.vue'
import { packageLimit } from '@/libs/packageLimits'
import { definitionId } from '@/libs/definitions'

const GUIDES_TAB_INDEX = 3

export default {
  name: 'TasksIndex',
  components: {
    BCard, BCardBody, BButton, BTabs, BTab, TasksTable, GuidesTable,
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  computed: {
    statusQueries() {
      const id = slug => definitionId('task', slug)
      return {
        active: { where_in: [['tasks.id_task_statuses', [id('open'), id('in_progress')]]] },
        completed: { where: { 'tasks.id_task_statuses': id('completed') } },
        cancelled: { where: { 'tasks.id_task_statuses': id('cancelled') } },
      }
    },
    // Dil değişince başlıklar güncellensin diye computed (#120 tuzağı)
    activeFields() {
      return [
        { key: 'title', label: this.$t('tasks.columns.title') },
        { key: 'watchers', label: this.$t('tasks.columns.watchers'), thClass: 'width-100' },
        { key: 'subtasks', label: this.$t('tasks.columns.subtasks'), thClass: 'width-150' },
        { key: 'priority', label: this.$t('fields.priority'), thClass: 'width-150' },
        { key: 'dept_team', label: this.$t('tasks.columns.deptTeam'), thClass: 'width-200' },
        { key: 'manager', label: this.$t('tasks.columns.manager'), thClass: 'width-200' },
        { key: 'target_date', label: this.$t('fields.targetDate'), thClass: 'width-150' },
        { key: 'created_info', label: this.$t('tasks.columns.createdBy'), thClass: 'width-150' },
        {
          key: 'control', label: '', thClass: 'width-150', tdClass: 'width-150 text-nowrap',
        },
      ]
    },
    completedFields() {
      return [
        { key: 'title', label: this.$t('tasks.columns.title') },
        { key: 'priority', label: this.$t('fields.priority'), thClass: 'width-150' },
        { key: 'manager', label: this.$t('tasks.columns.manager'), thClass: 'width-200' },
        { key: 'completed_date', label: this.$t('tasks.columns.completedDate'), thClass: 'width-150' },
        { key: 'control', label: '', thClass: 'width-150' },
      ]
    },
    cancelledFields() {
      return [
        { key: 'title', label: this.$t('tasks.columns.title') },
        { key: 'priority', label: this.$t('fields.priority'), thClass: 'width-150' },
        { key: 'manager', label: this.$t('tasks.columns.manager'), thClass: 'width-200' },
        { key: 'cancelled_date', label: this.$t('tasks.columns.cancelledDate'), thClass: 'width-150' },
        { key: 'control', label: '', thClass: 'width-150' },
      ]
    },
    showGuidesTab() {
      return this.$can('read', 'GUIDES_LIST') && packageLimit('PROJECTS', 1)
    },
    isGuidesTab() {
      return this.showGuidesTab && this.tabIndex === GUIDES_TAB_INDEX
    },
    canCreate() {
      return this.$can('read', this.isGuidesTab ? 'GUIDES_ADD' : 'TASKS_ADD')
    },
  },
  created() {
    if (this.showGuidesTab && this.$route.query.tab === 'guides') {
      this.tabIndex = GUIDES_TAB_INDEX
    }
  },
}
</script>
